import {jobActions, openwebActions} from '../actionTypes';
import { _trim, _get } from '../utils';
import createLogger from '../../utils/createLogger';
const DEBUG = false;
const debug = createLogger(DEBUG, `owpActions.js`);

/** ---------------- action creators ---------------- */
const getOpenWebJobsRequest = () => ({
  type: openwebActions.GET_OPENWEB_JOBS_REQUEST,
});

const getOpenWebJobDetailsRequest = (id) => ({
  type: openwebActions.GET_OPENWEB_JOB_REQUEST,
  id,
});

const flushOpenWebJobsCacheAction = () => ({
  type: openwebActions.FLUSH_OPENWEB_JOBS_CACHE,
});

const removeOpenWebJobRequest = (id) => ({
  type: openwebActions.PUT_OPENWEB_JOB_REQUEST,
  id,
  status: `closed`,
});

const promoteOpenWebJobRequest = (id, config) => ({
  type: openwebActions.PUT_OPENWEB_PROMOTE_REQUEST,
  id,
  ...config,
});

const clearOpenWebPageRequest = (ids) => ({
  type: openwebActions.PUT_OPENWEB_CLEAR_REQUEST,
  ids,
});

/** ---------------- action sequences ---------------- */

const initializeOpenWebJobData = () => {
  return (dispatch) => {
    debug.enter(`initializeOpenWebJobData`);
    dispatch(getOpenWebJobs());
  }
};

const getOpenWebJobs = () => {
  return (dispatch) => {
    debug.enter(`getOpenWebJobs`);
    return dispatch(getOpenWebJobsRequest());
  }
};

const getOpenWebJobDetails = (id) => {
  return (dispatch) => {
    console.log('getting openweb job details *****');
    dispatch(getOpenWebJobDetailsRequest(id));
  }
};

const removeOpenWebJob = (id, callback) => {
  return (dispatch) => {
    console.log('removing owp job ...........');
    dispatch(removeOpenWebJobRequest(id));
    if (typeof callback === `function`) {
      callback();
    }
  }
};

const promoteOpenWebJob = (id, config) => {
  return (dispatch) => {
    debug.enter(`promoteOpenWebJob`);
    console.log(id, config);
    return dispatch(promoteOpenWebJobRequest(id, {...config}))
  }
};

const clearOpenWebPage = (ids) => {
  debug.log(ids);
  return (dispatch) => {
    debug.enter(`clearOpenWebPage`);
    console.log(ids);
    return dispatch(clearOpenWebPageRequest(ids))
  }
};

const flushOpenWebJobsCache = () => {
  return (dispatch) => {
    debug.enter(`flushOpenWebJobsCache`);
    return dispatch(flushOpenWebJobsCacheAction());
  }
};

export {
  getOpenWebJobs,
  getOpenWebJobDetails,
  flushOpenWebJobsCache,
  removeOpenWebJob,
  promoteOpenWebJob,
  initializeOpenWebJobData,
  clearOpenWebPage,
}


// WEBPACK FOOTER //
// ./src/data/owp/owpActions.js